import HistRangePicker from "./HistRangePicker";

export default HistRangePicker;